module.exports = __webpack_public_path__ + "img/AddRoadOutlined.79efaa21.svg";